<!--
 * @Author: cgh
 * @Date: 2022-08-01 12:03:08
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:59:43
 * @Description: 评估项目添加/修改
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        {{ dlType === "pgxmEdit" ? "修改评估项目" : "添加评估项目" }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </k-button>
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->
    <hm-page-card class="c-card-detail">
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            基本信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              <el-input
                v-model="fd.xmmc"
                class="c-form__input"
                placeholder="请输入项目名称"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="所属区域"
              prop="areaDm"
            >
              <select-address
                v-model="fd.areaDm"
                required
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目地址"
              prop="xmdz"
            >
              <el-input
                v-model="fd.xmdz"
                class="c-form__input"
                placeholder="请输入项目地址"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="委托单位"
              prop="wtdw"
            >
              <el-input
                v-model.trim="fd.wtdw"
                class="c-form__input"
                placeholder="请输入委托单位"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="委托单位地址"
              prop="wtdwdz"
            >
              <el-input
                v-model.trim="fd.wtdwdz"
                class="c-form__input"
                placeholder="请输入委托单位地址"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="统一社会信用代码"
              prop="shxydm"
            >
              <el-input
                v-model="fd.shxydm"
                class="c-form__input"
                placeholder="请输入统一社会信用代码"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系人"
              prop="lxr"
            >
              <el-input
                v-model.trim="fd.lxr"
                class="c-form__input"
                placeholder="请输入联系人"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="lxdh"
            >
              <el-input
                v-model="fd.lxdh"
                class="c-form__input"
                placeholder="请输入联系电话"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="建筑类型"
              prop="jzlbDm"
            >
              <el-select
                v-model="fd.jzlbDm"
                class="c-form__select"
                placeholder="请选择建筑类别"
                clearable
              >
                <el-option
                  v-for="item in jzlbType"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="管理单位"
              prop="gldw"
            >
              <el-input
                v-model="fd.gldw"
                class="c-form__input"
                placeholder="请输入管理单位"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="维保单位"
              prop="wbdw"
            >
              <el-input
                v-model="fd.wbdw"
                class="c-form__input"
                placeholder="请输入维保单位"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col  c-form__placeholder"
            :span="12"
          />
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="单位基本情况"
              prop="dwjbqk"
            >
              <span style="font-size: 8px; color: #e6a23c;">
                ** 可根据实际情况增减 **
              </span>
              <el-input
                v-model="fd.dwjbqk"
                type="textarea"
                :rows="4"
                class="c-form__input"
                placeholder="请输入单位基本情况"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="建筑基本信息"
              prop="jzjbqk"
            >
              <el-input
                v-model="fd.jzjbqk"
                type="textarea"
                :rows="4"
                class="c-form__input"
                placeholder="请输入建筑基本信息"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          style="margin-top: 10px;"
          class="c-form__row"
        >
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            评估信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="评估日期"
              prop="pgrq"
            >
              <hm-date-range
                v-model="fd.pgrq"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :clearable="true"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="dlTypeFlag"
            :span="12"
            class="c-form__col"
          >
            <el-form-item
              class="c-form__item"
              label="签到信息"
              prop="qdxxList"
            >
              <template v-if="fd.qdxxList && fd.qdxxList.length > 0">
                <span
                  class="c-form__read"
                >{{ fd.qdxxList[0].qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                  {{ fd.qdxxList[0].qdr }} {{ fd.qdxxList[0].qddz }}
                </span>
                <el-popover
                  v-if="fd.qdxxList.length > 1"
                  placement="right"
                  trigger="click"
                >
                  <div
                    v-for="(item, index) in fd.qdxxList"
                    :key="index"
                  >
                    <span
                      class="c-form__read"
                    >{{ item.qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                      {{ item.qdr }} {{ item.qddz }}
                    </span>
                  </div>
                  <el-link
                    slot="reference"
                    type="primary"
                    :underline="false"
                  >
                    详情
                  </el-link>
                </el-popover>
              </template>
            </el-form-item>
          </el-col>
          <el-col
            v-if="!dlTypeFlag"
            class="c-form__col  c-form__placeholder"
            :span="12"
          />
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="报告编写人"
              prop="bgbxr"
            >
              <select-xm-user
                v-model="fd.bgbxr"
                class="c-form__select"
                placeholder="请选择报告编写人"
                role-code="JX-PG"
                :show-dept="false"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目负责人"
              prop="xmfzr"
            >
              <select-xm-user
                v-model="fd.xmfzr"
                placeholder="请选择项目负责人"
                role-code="JX-XMFZR"
                :show-dept="false"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="报告审批人"
              prop="bgspr"
            >
              <select-xm-user
                v-model="fd.bgspr"
                class="c-form__select"
                placeholder="请选择报告审批人"
                role-code="JX-PG"
                :show-dept="false"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="报告批准人"
              prop="bgpzr"
            >
              <select-xm-user
                v-model="fd.bgpzr"
                placeholder="请选择报告批准人"
                role-code="JX-XMFZR"
                :show-dept="false"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="评估范围"
              prop="pgfw"
            >
              <el-input
                v-model="fd.pgfw"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder="请输入评估范围"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="评估依据"
              prop="pgyj"
            >
              <span style="font-size: 8px; color: #e6a23c;">
                ** 可根据实际情况增减 **
              </span>
              <el-input
                v-model="fd.pgyj"
                type="textarea"
                :rows="4"
                class="c-form__input"
                placeholder="请输入评估依据"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="dlTypeFlag"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="评估情况说明"
              prop="pgqksm"
            >
              <el-input
                v-model="fd.pgqksm"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder="请输入评估情况说明"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </hm-page-card>
  </div>
</template>

<script>
import { pgxmManageService } from './pgxm.service';
export default {
  name: 'PgxmUpdateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示
      xmId: null,

      /* 表单参数 Start */
      fd: {
        wtdw: null, // 委托单位
        lxr: null, // 联系人
        wtdwdz: null, // 委托单位地址
        lxdh: null, // 联系电话
        xmmc: null, // 项目名称
        shxydm: null, // 统一社会信用代码
        areaDm: null, // 所属区域
        xmdz: null, // 项目地址
        pgrq: [], // 评估日期
        pgrqQ: null, // 评估日期起
        pgrqZ: null, // 评估日期止
        qdxxList: [
          {
            qdsj: null, // 签到时间
            qdr: null, // 签到人
            qddz: null // 签到地址
          }
        ],
        jzlbDm: null, // 建筑类型
        bgbxr: null, // 报告编写人
        xmfzr: null, // 项目负责人
        bgspr: null, // 报告审批人
        bgpzr: null, // 报告批准人
        gldw: null, // 管理单位
        wbdw: null, // 维保单位
        pgfw: '本消防技术服务机构对××××建筑物的××××××××进行消防安全评估。', // 评估范围
        pgyj: 'XF/T 3005-2020《单位消防安全评估》\nGB 25201《建筑消防设施的维护管理》\nGB 25506《消防控制室通用技术要求》\nGB 50016《建筑设计防火规范》\nGB 50116《火灾自动报警系统设计规范》\nGB 50140《建筑灭火器配置设计规范》', // 评估依据
        dwjbqk:
          'XXX单位位于江西省XX区（县）XX路XX号，属于XX类型（人员密集场所和地下公共建筑、高层公共建筑、易燃易爆场所、全国重点文物保护单位）。该单位（XX建筑或场所×层）于××年×月消防设计审核合格，××年×月通过消防验收。建筑的主要功能，建筑类别，耐火等级，火灾危险性分类，主要危险物质情况，总建筑面积××平方米，地上×层，地下×层，建筑高度××米；地下×层为××，×层至×层为××，建筑面积××平方米，×层、×层为××，建筑面积××平方米；竣工日期，竣工图纸提供情况，依法取得消防行政审批手续情况；主要消防设施有火灾自动报警系统、自动喷水灭火系统、机械排烟系统、火灾应急照明系统、消火栓系统等。近一年未发生火灾，未出现消防救援机构责令改正的消防违法行为。', // 单位基本情况
        jzjbqk: null, // 建筑基本信息
        pgqksm: null, // 评估情况说明
        bgbh: null, // 报告编号
        bgUrl: null, // 查看报告编号
        ztDm: null // 状态代码
      },
      /* 表单参数 End */
      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      /* 表单校验规则 Start */
      fdRules: {
        wtdw: [this.$validUtils.required('委托单位'), this.$HMValidator.maxLength('委托单位', 300)],
        lxr: [this.$validUtils.required('联系人'), this.$HMValidator.maxLength('联系人', 50)],
        wtdwdz: [this.$validUtils.required('委托单位地址'), this.$HMValidator.maxLength('委托单位地址', 500)],
        lxdh: [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.number('联系电话'),
          this.$validUtils.phone('联系电话')
        ],
        xmmc: [
          this.$validUtils.required('项目名称'),
          this.$HMValidator.maxLength('项目名称', 300)],
        shxydm: [
          this.$validUtils.required('统一社会信用代码'),
          this.$HMValidator.tyshxydm('统一社会信用代码')
        ],
        areaDm: [this.$validUtils.required('所属区域')],
        xmdz: [this.$validUtils.required('项目地址'), this.$HMValidator.maxLength('项目地址', 500)],
        jzlbDm: [this.$validUtils.required('建筑类型')],
        bgbxr: [this.$validUtils.required('报告编写人'), this.$HMValidator.maxLength('报告编写人', 50)],
        xmfzr: [this.$validUtils.required('项目负责人'), this.$HMValidator.maxLength('项目负责人', 50)],
        bgspr: [this.$validUtils.required('报告审批人'), this.$HMValidator.maxLength('报告审批人', 50)],
        bgpzr: [this.$validUtils.required('报告批准人'), this.$HMValidator.maxLength('报告批准人', 50)],
        pgfw: [this.$validUtils.required('评估范围'), this.$HMValidator.maxLength('评估范围', 1000)],
        pgrq: [
          this.$HMValidator.dateRange('评估时间'),
          this.$HMValidator.dateRangeAllMust('评估时间')
        ],
        gldw: [this.$HMValidator.maxLength('管理单位', 300)],
        dwjbqk: [this.$HMValidator.maxLength('单位基本情况', 1000)],
        jzjbqk: [this.$HMValidator.maxLength('建筑基本信息', 1000)],
        pgyj: [this.$HMValidator.maxLength('评估依据', 1000)],
        pgqksm: [this.$HMValidator.maxLength('评估情况说明', 1000)],
        wbdw: [this.$HMValidator.maxLength('维保单位', 300)]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlType () {
      return this.$route.name;
    },
    dlTypeFlag () {
      return this.$route.name === 'jxxfPgxmEdit';
    },
    /* 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_PG) {
        return enums.IFF_JZLB_PG;
      }
      return {};
    },
    pgyjType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.PGXM_PGYJLX) {
        return enums.PGXM_PGYJLX;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 初始化维保建筑信息
     * @return {*}
     */
    init () {
      this.loading = true;
      pgxmManageService
        .getDetail(this.xmId)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          // 初始化评估日期
          this.fd.pgrq = [rsp.data.pgrqQ, rsp.data.pgrqZ];
        })
        .catch(err => {
          console.error('获取评估项目信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
      // 是否需要签章和盖章
      // this.isNeedQGz();
    },
    /**
     * @description: 跳转窗口
     * @author: cgh
     */
    handleDialog (_name) {
      this.showDialogName = _name;
      this.dialogParams = { id: this.xmId, type: 'edit' };
    },
    /**
     * @description: 跳转评估明细窗口
     * @author: cgh
     */
    handlePgmxDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate(valid => {
        const _this = this;
        if (valid) {
          _this.fd.pgrqQ = _this.fd.pgrq[0];
          _this.fd.pgrqZ = _this.fd.pgrq[1];
          if (this.dlType === 'jxxfPgxmAdd') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    // 跳转pdf路径
    handlePdfDialog (_url) {
      window.open(_url, '_blank');
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      this.loading = true;
      pgxmManageService
        .save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              this.closeNavTabAndTo(
                {
                  name: 'jxxfPgxmManage',
                  params: { isRefresh: true }
                },
                true
              );
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      this.loading = true;
      pgxmManageService
        .update(this.xmId, this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              this.closeNavTabAndTo(
                {
                  name: 'jxxfPgxmManage',
                  params: { isRefresh: true }
                },
                true
              );
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
        });
      this.loading = false;
    },
    /**
     * @description 关闭
     * @param {*}
     * @return {*}
     */
    handleClose () {
      this.closeNavTabAndTo();
    }
  },
  created () {
    if (this.dlType === 'jxxfPgxmEdit') {
      this.xmId = this.$route.params.id;
      this.init();
    }
  }
};
</script>
<style scoped>
.o-text-co {
  font: 1em sans-serif;
  color: red;
  text-decoration: none;
}
</style>
